export default "__VITE_ASSET__CEejvufc__"